export const getLoggedInUserInfo = () => {
  const loggedInUserStr = typeof window !== "undefined" ? localStorage.getItem("user") : null;
  const loggedInUser = loggedInUserStr ? JSON.parse(loggedInUserStr) : null;
  const userRole = (loggedInUser?.roleDetails?.name || loggedInUser?.role || "").toLowerCase();
  const isSuperOrStoreAdmin =
    userRole === "super admin" ||
    userRole === "store admin" ||
    userRole === "admin" ||
    userRole === "super_admin" ||
    userRole === "store_admin";
  const userEmail = (loggedInUser?.email || "").toLowerCase();
  const userId = (loggedInUser?._id || loggedInUser?.id || "").toString();

  return {
    loggedInUser,
    userRole,
    isSuperOrStoreAdmin,
    userEmail,
    userId
  };
};

export const filterConsultationTypesForUser = (allTypes = [], isSuperOrStoreAdmin, userId, userEmail) => {
  if (isSuperOrStoreAdmin) return allTypes;
  return allTypes.filter((t) => {
    const mgrId = t.assignedManagerId ? t.assignedManagerId.toString() : "";
    const mgrEmail = (t.assignedManagerEmail || "").toLowerCase();
    return (userId && mgrId === userId) || (userEmail && mgrEmail === userEmail);
  });
};
